module.exports = __webpack_public_path__ + "static/media/search.6abeb37b.svg";